import React from 'react';
import { connect } from 'react-redux';

const Support = React.createClass({
  render() {
    const { account, isAuthenticated, className } = this.props;
    let bodyString = '';
    if (isAuthenticated && account) {
      const userEmail = account.get('email');
      bodyString = `&body=%0D%0A%0D%0AMy%%20username%20is%20${userEmail}`;
    }
    return (
      <a
        className={className || ''}
        href={`mailto:fernando@nuancedinterpretation.com?subject=Help%20with%20Nuanced Interpretation Client Portal${bodyString}`}
      >
        fernando@nuancedinterpretation.com
      </a>
    );
  }
});

const mapStateToProps = state => ({
  isAuthenticated: state.auth.get('isAuthenticated'),
  account: state.auth.get('user')
});

export const SupportEmail = connect(mapStateToProps)(Support);



/** WEBPACK FOOTER **
 ** ./src/components/layout/support-email.jsx
 **/